// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__36MFH","col":"Table_col__3fSv5","fulfillmentStatus":"Table_fulfillmentStatus__3tuHI","emailCol":"Table_emailCol__ZmhYj"};